import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { LoadingState, ErrorState } from '../types';

interface UIState {
  // Loading state
  loading: LoadingState;

  // Error state
  error: ErrorState;

  // Modal states
  showUploadModal: boolean;
  showConfigModal: boolean;
  showResultsModal: boolean;

  // Sidebar state
  sidebarOpen: boolean;

  // Actions
  setLoading: (loading: Partial<LoadingState>) => void;
  setError: (error: Partial<ErrorState>) => void;
  clearError: () => void;
  setShowUploadModal: (show: boolean) => void;
  setShowConfigModal: (show: boolean) => void;
  setShowResultsModal: (show: boolean) => void;
  toggleSidebar: () => void;
}

export const useUIStore = create<UIState>()(
  devtools(
    set => ({
      loading: {
        isLoading: false,
      },
      error: {
        hasError: false,
      },
      showUploadModal: false,
      showConfigModal: false,
      showResultsModal: false,
      sidebarOpen: true,

      setLoading: loading =>
        set(state => ({
          loading: { ...state.loading, ...loading },
        })),

      setError: error =>
        set(state => ({
          error: { ...state.error, ...error, hasError: true },
        })),

      clearError: () =>
        set({
          error: { hasError: false },
        }),

      setShowUploadModal: show => set({ showUploadModal: show }),

      setShowConfigModal: show => set({ showConfigModal: show }),

      setShowResultsModal: show => set({ showResultsModal: show }),

      toggleSidebar: () => set(state => ({ sidebarOpen: !state.sidebarOpen })),
    }),
    { name: 'UIStore' }
  )
);
